import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const FormTypeAhead = () => (
  <ComponentDocs
    name="<Form.TypeAhead/>"
    entry="TypeAhead"
    propsEntry="TypeAheadProps"
    namespace="FormFields"
    externalProps={ExternalProps.MuiAutocomplete}
  >
    <ComponentExample
      name="Lookup connected type-ahead"
      description="TypeAhead options can be supplied by a registered lookup for data that changes infrequently."
      import={import(
        "examples/Forms/FormTypeAhead/LookupConnectedTypeAheadExample"
      )}
      rawImport={import(
        "examples/Forms/FormTypeAhead/LookupConnectedTypeAheadExample?raw"
      )}
    />
    <ComponentExample
      name="Auto lookup registration"
      description="The lookupAction prop can be supplied an API action creator for data that changes frequently."
      import={import(
        "examples/Forms/FormTypeAhead/LookupActionTypeAheadExample"
      )}
      rawImport={import(
        "examples/Forms/FormTypeAhead/LookupActionTypeAheadExample?raw"
      )}
    />
    <ComponentExample
      name="Type-ahead value field"
      description="The valueField prop automatically populates the value of the selected option into a secondary field, to simplify passing the value to an API endpoint."
      import={import("examples/Forms/FormTypeAhead/TypeAheadValueFieldExample")}
      rawImport={import(
        "examples/Forms/FormTypeAhead/TypeAheadValueFieldExample?raw"
      )}
    />
    <ComponentExample
      name="Multi-select type-ahead"
      import={import(
        "examples/Forms/FormTypeAhead/MultiSelectTypeAheadExample"
      )}
      rawImport={import(
        "examples/Forms/FormTypeAhead/MultiSelectTypeAheadExample?raw"
      )}
    />
    <ComponentExample
      name="Type-ahead with additions"
      description="An end user can enter a custom value in a type-ahead by using the allowAdditions prop."
      import={import(
        "examples/Forms/FormTypeAhead/TypeAheadWithAdditionsExample"
      )}
      rawImport={import(
        "examples/Forms/FormTypeAhead/TypeAheadWithAdditionsExample?raw"
      )}
    />
    <ComponentExample
      name="Show initial suggestions"
      description="The searchSuggestions prop can be used to populate the type-ahead with initial options when it's first opened."
      import={import(
        "examples/Forms/FormTypeAhead/ShowInitialSuggestionsExample"
      )}
      rawImport={import(
        "examples/Forms/FormTypeAhead/ShowInitialSuggestionsExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormTypeAhead;
